var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppNavigationItem',{attrs:{"title":_vm.title},on:{"click":_vm.openUserSettings}},[_c('AlertCircleIcon',{attrs:{"slot":"icon","size":20,"decorative":""},slot:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }